var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-checkbox",
    {
      staticClass: "ui-checkbox",
      attrs: { value: !_vm.value },
      on: {
        change: function ($event) {
          return _vm.$emit("input", !_vm.value)
        },
      },
    },
    [
      _vm._v("\n\t" + _vm._s(_vm.label) + "\n\t"),
      _vm.tooltip ? _c("md-tooltip", [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }